import React from "react";
import { BaseRoundButton } from "@/shared/components/button/base-round-button";
import { BasePageModal } from "@/shared/components/modal/page-modal/base-page-modal";

interface Props {
  cancelType: "share" | "invite" | undefined;
  targetMail?: string;
  onTapConfirm: () => void;
  onTapCloseModal: () => void;
}

export const ShareMemberCancelConfirmModal = ({
  cancelType,
  targetMail,
  onTapCloseModal,
  onTapConfirm,
}: Props) => {
  const confirmMessage =
    cancelType === "invite"
      ? "本当に招待を取り消しますか？"
      : "本当に共有を解除しますか？";

  return (
    <BasePageModal
      title="確認"
      className="md-share-confirm"
      handleClose={onTapCloseModal}
      bottomChildren={[
        <BaseRoundButton
          key="cancel"
          buttonText="キャンセル"
          className="btn-cancel"
          onClick={onTapCloseModal}
        />,
        <BaseRoundButton
          key="confirm"
          buttonText={cancelType === "invite" ? "招待を取り消す" : "共有を解除する"}
          onClick={onTapConfirm}
        />,
      ]}
    >
      <>
        <h2>{confirmMessage}</h2>
        {targetMail && <p>{targetMail}</p>}
        <p>再度{cancelType === "invite" ? "招待" : "共有"}するには、あらためて共有設定を行う必要があります</p>
      </>
    </BasePageModal>
  );
};
